<script>
  import Resizer from "./resizer.svelte"

  export let dimensions = {}

  let enableDrag = false
  export let coordinate = ""
  export let autoCropDetails = {}

  /**
   * Adjusts the position of the signature image element based on mouse movements over the position overlay.
   *
   * @param {MouseEvent} e - The mouse event object containing information about the mouse position.
   */
  const positionOverlayMouseCapture = (e) => {
    if (!enableDrag) return

    let cropElem = e.target
    if (!cropElem) return

    let positionOverlay = cropElem.parentElement
    if (!positionOverlay) return

    let childElemWidth = parseFloat(getComputedStyle(cropElem).width)
    let childElemHeight = parseFloat(getComputedStyle(cropElem).height)

    let offsetX = e.clientX - positionOverlay.getBoundingClientRect().left
    let offsetY = e.clientY - positionOverlay.getBoundingClientRect().top

    // Calculate the ratio of the actual document size to the displayed overlay size
    // let yRatio = dimensions.height / positionOverlay.clientHeight
    // let xRatio = dimensions.width / positionOverlay.clientWidth

    let yRatio = dimensions.clientWidth / dimensions.width
    let xRatio = dimensions.clientHeight / dimensions.height

    // Initialize variables for x and y positions
    let x = 0
    let y = 0

    // Determine if the mouse pointer is closer to the bottom or top of the position overlay
    let bottom = positionOverlay.clientHeight > offsetY + childElemHeight / 2
    let top = offsetY - childElemHeight / 2 > 0

    // Determine if the mouse pointer is closer to the right or left of the position overlay
    let right = positionOverlay.clientWidth > offsetX + childElemWidth / 2
    let left = offsetX - childElemWidth / 2 > 0

    // console.log(bottom, top, right, left, "final pos")

    // Calculate the y position of the signature image based on mouse pointer location
    if (!bottom && top) {
      // If closer to the top and not at the bottom, position near the bottom of the overlay
      y = positionOverlay.clientHeight - childElemHeight
    }
    if (bottom && !top) {
      // If closer to the bottom and not at the top, position at the top of the overlay
      y = 0
    }
    if (bottom && top) {
      // If both conditions meet, position at the mouse pointer's vertical midpoint
      y = offsetY - childElemHeight / 2
    }

    // Otherwise, position based on proximity to overlay edges
    if (!left && right) {
      // If closer to the right and not to the left, position at the left edge of the overlay
      x = 0
    }
    if (left && !right) {
      // If closer to the left and not to the right, position at the right edge of the overlay
      x = positionOverlay.clientWidth - childElemWidth
    }
    if (left && right) {
      // If both conditions meet, position at the mouse pointer's horizontal midpoint
      x = offsetX - childElemWidth / 2
    }

    // Set the left and top styles of the signature image element to position it on the overlay
    cropElem.style.left = Math.floor(x) + "px"
    cropElem.style.top = Math.floor(y) + "px"

    // Calculate the scaled coordinates for the signature position and update position
    let x1 = Math.floor(x / xRatio)
    let y1 = Math.floor(y / yRatio)
    let x2 = Math.round(childElemWidth / xRatio)
    let y2 = Math.round(childElemHeight / yRatio)

    coordinate = `${x1}, ${y1}, ${x2}, ${y2}`

    // console.log({ coordinate })
  }
</script>

<Resizer
  {dimensions}
  {autoCropDetails}
  bind:coordinate
  on:mousedown={() => {
    enableDrag = true
  }}
  on:mousemove={positionOverlayMouseCapture}
  on:mouseup={() => {
    enableDrag = false
  }}
  on:mouseleave={() => {
    enableDrag = false
  }}
/>
